import React, { useMemo } from "react";
import { Redirect, useLocation } from "react-router-dom";
import useCustomDomain from "hooks/useCustomDomain";
import { Routes } from "../config";

export default function LinkedModalPageView({ path }: { path: string }) {
  const location = useLocation();
  const { isCustomDomain } = useCustomDomain();
  const to = useMemo(
    () => ({
      ...location,
      pathname: path,
      state: {
        location: {
          pathname: isCustomDomain ? Routes.root : Routes.home,
        },
      },
    }),
    [isCustomDomain, location, path]
  );
  return <Redirect to={to} />;
}
